<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>
                        <b-col lg="9">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                                size="sm"></b-pagination>
                        </b-col>
                    </b-row>
                </div>

                <b-card class="sa-card sa-card-border" header-tag="header" footer-tag="footer" title="">
                    <template #header>
                        <div class="d-flex justify-content-between align-items-center custom-header">
                            <span>Appuntamenti</span>
                            <b-button size="sm" variant="success" @click="onClickAggiungiAccessoDiretto">Aggiungi
                                Accesso
                                Diretto</b-button>
                        </div>
                    </template>
                    <div class="b-table-sticky-header">
                        <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                            :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left
                            head-variant="light" class="sa-b-table" sort-by="numeroOrdine" :sort-desc="false">
                            <template #cell(riferimento)="row">
                                <strong style="font-size: small; display: inline-block;">

                                    {{ formatDate(row.item.dataOraInizio) }}
                                    <small> {{ getGiornoSettimana(row.item.dataRiferimento).toUpperCase() }}</small>

                                    <br>
                                    {{ getOrario(row.item.dataOraInizio) }} - {{ getOrario(row.item.dataOraFine) }}
                                </strong>
                            </template>
                            <template #cell(identificativoAppuntamento)="row">
                                <b style="font-style: italic;">{{ row.item.identificativoAppuntamento }}</b>
                                <br />
                                <small>{{ row.item.cognome }} {{ row.item.nome }}</small>
                            </template>
                            <template #cell(nre)="row">
                                <span style="font-weight: 700; " v-if="row.item.codiceBar1 != 'PVT'">
                                    <span style="width:100%; display: inline-block;">{{ row.item.codiceBar1 }} {{
                                        row.item.codiceBar2
                                    }}</span>
                                </span>
                                <span v-else>
                                    <span style="font-weight: 700; width:100%; display: inline-block;">{{
                                        row.item.codiceBar1 }} </span>
                                    <span style="font-weight: 700; width:100%; display: inline-block;">
                                        {{ row.item.codiceBar2
                                        }}</span>
                                </span>
                            </template>

                            <template #cell(descrizionePrestazione)="row">
                                <strong style="width: 100%; display: inline-block;">{{
                                    row.item.descrizionePrestazione }}</strong>
                                <span style="font-size: small; display: inline-block;">
                                    {{ getInfoAgenda(row.item) }}
                                </span>
                            </template>
                            <template #cell(ciclo)="row">
                                <span style="font-size: small; display: inline-block; width: 100%;">
                                    Accesso n° <b>{{ row.item.numeroOrdine }}</b>
                                </span>
                                <small>n° {{ row.item.numeroOrdine }} / {{ row.item.quantitaErogabile }} Accessi</small>
                            </template>
                            <template #cell(statoAttuale)="row">
                                <strong style="width: 100%;display: inline-block; ">{{ row.item.statoAttuale }}</strong>

                                <span style="font-size: small; display: inline-block;">
                                    {{ formatDate(row.item.statoAttualeDataOra) }}
                                </span>
                            </template>

                            <template #cell(actions)="row">
                                <b-container style="gap:8px">

                                    <b-button
                                        :disabled="row.item.statoAttuale == 'EROGATO' || row.item.statoAttuale == 'ESEGUITO' || row.item.statoAttuale == 'NON ESEGUITO'"
                                        variant="btn btn-primary waves-effect waves-light width-sm no-text"
                                        @click="onChangeStatoPrenotazione(row.item)">
                                        <i class="bi bi-arrow-repeat"></i>
                                    </b-button>
                                    <b-button
                                        :disabled="row.item.statoAttuale == 'EROGATO' || row.item.statoAttuale == 'ESEGUITO' || row.item.statoAttuale == 'NON ESEGUITO'"
                                        variant="btn btn-purple waves-effect waves-light width-sm no-text"
                                        @click="gestioneAppuntamenti(row.item)">
                                        <b-icon icon="gear"></b-icon>
                                    </b-button>
                                    <b-button
                                        :disabled="row.item.statoAttuale == 'EROGATO' || row.item.statoAttuale == 'ESEGUITO' || row.item.statoAttuale == 'NON ESEGUITO'"
                                        variant="btn btn-danger waves-effect waves-light width-sm no-text"
                                        @click="onClickEliminaAppuntamento(row.item)">
                                        <b-icon icon="trash"></b-icon>
                                    </b-button>
                                </b-container>
                            </template>

                        </b-table>
                    </div>
                </b-card>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <b-modal ref="mdlChangeStato" @hide="onHideChangeStato" title="Cambio Stato Appuntamento" hide-footer>
                <b-form>
                    <b-row>
                        <b-col cols="10">
                            <label>Stato</label>
                            <b-form-select @change="onChangeSelectStato" v-model="jsonData.stato"
                                :options="orderStutusOptions"></b-form-select>
                        </b-col>

                        <b-col cols="2">
                            <label for=""></label>
                            <b-container class="d-flex gap-3">
                                <b-button variant="outline-primary" @click="onCambiaStato()">
                                    <b-icon icon="gear" aria-hidden="true"></b-icon>
                                </b-button>
                            </b-container>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
            <b-modal size="lg" @hide="onHide" ref="mdlGestioneAppuntamento" title="Appuntamento Scheduler"
                @shown="onShownGestioneAppuntamento">
                <template v-if="tabSpostaAppuntamento == 1">
                    <b-row>
                        <b-col cols="6">
                            <b-row>
                                <b-col cols="12">
                                    <label class="w-100">Appuntamenti di {{
                                        appuntamentoSelRow.identificativoAppuntamento
                                        }}</label>
                                    <label class="w-100">Prestazione e Codice</label>
                                    <span> {{ appuntamentoSelRow.descrizionePrestazione }} ({{
                                        appuntamentoSelRow.codicePrestazione
                                        }})</span>
                                </b-col>

                                <b-col cols="12" v-if="appuntamentoSelezionatoDaSpostare != null">
                                    <label class="font-weight-bold">Sposta Appuntamento</label>

                                    <b-row>
                                        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                            <b-form-group label="Agenda" class="sa-ft-label">
                                                <b-form-select v-model="spostaAppuntamentoJsonData.idAgenda"
                                                    :options="agendaOptions" value-field="id" text-field="titolo"
                                                    :disabled="true">
                                                    <template #first>
                                                        <b-form-select-option :value="null"
                                                            disabled>Seleziona</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>

                                        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                            <b-form-group label="Data Riferimento" class="sa-ft-label">
                                                <date-picker v-model="dataRiferimentoDate" format="DD-MM-YYYY"
                                                    value-type="timestamp" placeholder="Seleziona Data" type="date"
                                                    class="w-100"> </date-picker>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>

                        </b-col>
                        <b-col cols="6">
                            <b-row>
                                <b-col cols="12" class="mb-3">
                                    <div class="p-2 border rounded" style="background-color: #f8f9fa;">
                                        <label class="w-100 font-weight-bold">Dettaglio Vecchio Appuntamento</label>
                                        <b-row>
                                            <b-col md="4">
                                                <small class="text-muted d-block">Data Riferimento</small>
                                                <strong class="w-100 d-block">{{
                                                    formattaData(appuntamentoSelezionatoDaSpostare.dataRiferimento)
                                                    }}</strong>
                                                <small>{{
                                                    getGiornoSettimana(appuntamentoSelezionatoDaSpostare.dataRiferimento).toUpperCase()
                                                    }}</small>
                                            </b-col>
                                            <b-col md="4">
                                                <small class="text-muted d-block">Orario</small>
                                                <strong>
                                                    {{ getOrario(appuntamentoSelezionatoDaSpostare.dataOraInizio) }}
                                                    -
                                                    {{ getOrario(appuntamentoSelezionatoDaSpostare.dataOraFine) }}
                                                </strong>
                                            </b-col>
                                            <b-col md="4">
                                                <small class="text-muted d-block">Info Appuntamento</small>
                                                <strong>Accesso n° {{ appuntamentoSelezionatoDaSpostare.numeroOrdine
                                                    }}</strong>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                                <b-col cols="12">
                                    <div class="p-2 border rounded" style="background-color: #f8f9fa;"
                                        v-if="nuovaDisponibilitaSelezionata">
                                        <label class="w-100 font-weight-bold">Dettaglio Nuovo Appuntamento</label>
                                        <b-row>
                                            <b-col md="4">
                                                <small class="text-muted d-block">Data Riferimento</small>
                                                <strong class="w-100 d-block">{{
                                                    formattaData(spostaAppuntamentoJsonData.dataRiferimento)
                                                    }}</strong>
                                                <small>{{
                                                    getGiornoSettimana(spostaAppuntamentoJsonData.dataRiferimento).toUpperCase()
                                                    }}</small>
                                            </b-col>
                                            <b-col md="4">
                                                <small class="text-muted d-block">Orario</small>
                                                <strong>
                                                    {{ getOrario(spostaAppuntamentoJsonData.dataOraInizio) }}
                                                    -
                                                    {{ getOrario(spostaAppuntamentoJsonData.dataOraFine) }}
                                                </strong>
                                            </b-col>
                                            <b-col md="4">
                                                <small class="text-muted d-block">Info Appuntamento</small>
                                                <strong>Accesso n° {{ spostaAppuntamentoJsonData.numeroOrdine
                                                    }}</strong>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div v-else class="p-2 border rounded "
                                        style="background-color: #f8f9fa;height:85px ">
                                        Seleziona Orario per schedulare nuovo appuntamento
                                    </div>
                                </b-col>
                            </b-row>



                        </b-col>
                    </b-row>

                    <b-row class="mt-3">
                        <b-col cols="8">
                            <label for="">Seleziona un Appuntamento </label>
                            <div class="b-table-sticky-header" style="height: 300px;">
                                <b-table selectable sticky-header ref="table" stacked="xl" striped hover
                                    :items="prestazioneSelezionata.appuntament" select-mode="single"
                                    :fields="fieldAppuntamenti" sort-by="numeroOrdine" @row-selected="setRowSelected"
                                    sort-icon-left head-variant="light" class="sa-b-table">
                                    <template #cell(index)="row">
                                        {{ row.index + 1 }}
                                    </template>
                                    <template #cell(numeroOrdine)="row">
                                        <strong style="width: 100%; display: inline-block;">{{
                                            row.item.numeroOrdine }}</strong>

                                    </template>
                                    <template #cell(riferimento)="row">
                                        <strong style="font-size: small; display: inline-block;">
                                            <strong class="w-100 d-block">{{
                                                formattaData(row.item.dataRiferimento)
                                                }}</strong>
                                            <small>{{
                                                getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                                                }}</small>
                                            <br>
                                            {{ getOrario(row.item.dataOraInizio) }} - {{
                                                getOrario(row.item.dataOraFine)
                                            }}
                                        </strong>
                                    </template>
                                    <template #cell(statoAttuale)="row">
                                        <strong style="font-size: small; display: inline-block;">
                                            {{ row.item.statoAttuale }}
                                            <br>

                                        </strong>
                                    </template>
                                </b-table>
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <label>Seleziona Nuova Disponibilità</label>
                            <div class="b-table-sticky-header" style="height: 300px;">
                                <b-table selectable ref="tblDisponibilita" select-mode="single" striped hover
                                    :items="disponibilitaAgendaItems[0].disponibilita" :fields="fieldDisponibilita"
                                    @row-selected="onDisponibilitaSelected" head-variant="light">
                                    <template #cell(seleziona)="row">
                                        <b-icon :icon="row.rowSelected ? 'check-circle-fill' : 'circle'"
                                            :variant="row.rowSelected ? 'primary' : 'secondary'"></b-icon>
                                    </template>
                                    <template #cell(dataRiferimento)="row">
                                        <strong style="font-size: small; display: inline-block;">
                                            {{ formattaData(row.item.dataRiferimento) }}
                                            <br>
                                            <small> {{ getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                                                }}</small>
                                            <br>
                                            <strong style="font-size: small; display: inline-block;">
                                                {{ row.item.dalleOre }} - {{
                                                    row.item.alleOre
                                                }}
                                            </strong>
                                        </strong>
                                    </template>
                                </b-table>
                            </div>
                        </b-col>
                    </b-row>

                </template>
                <template v-if="tabSpostaAppuntamento == 2">
                    <label class="sa-ft-label">Nuovo Schema Appuntamenti</label>
                    <div class="b-table-sticky-header" style="height: 500px;">
                        <b-table sticky-header ref="table" stacked="xl" striped hover :items="appuntamentiTmpConferma"
                            :fields="fieldAppuntamenti" sort-icon-left head-variant="light" class="sa-b-table">
                            <template #cell(index)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(numeroOrdine)="row">
                                <strong style="width: 100%; display: inline-block;">{{
                                    row.item.numeroOrdine }}</strong>

                            </template>
                            <template #cell(riferimento)="row">
                                <strong style="font-size: small; display: inline-block;">
                                    <strong class="w-100 d-block">{{
                                        formattaData(row.item.dataRiferimento)
                                        }}</strong>
                                    <small>{{
                                        getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                                        }}</small>
                                    <br>
                                    {{ getOrario(row.item.dataOraInizio) }} - {{
                                        getOrario(row.item.dataOraFine)
                                    }}
                                </strong>
                            </template>
                            <template #cell(statoAttuale)="row">
                                <strong style="font-size: small; display: inline-block;">
                                    {{ row.item.statoAttuale }}
                                    <br>

                                </strong>
                            </template>
                        </b-table>
                    </div>

                </template>

                <template #modal-footer>
                    <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">

                        <b-button variant="danger" v-if="tabSpostaAppuntamento == 1"
                            @click="onAnnullaSpostaAppuntamento">Annulla</b-button>

                        <b-button variant="secondary" @click="tabSpostaAppuntamento = 1">Indietro</b-button>

                        <b-button variant="success" v-if="tabSpostaAppuntamento == 1"
                            @click="tabSpostaAppuntamento = 2"> Conferma
                        </b-button>

                        <b-button variant="success" v-if="tabSpostaAppuntamento == 2"
                            @click="onClickSpostaAppuntamento"> Sposta Appuntamento
                        </b-button>
                        <!-- <b-button variant="success" v-if="tab == 2 && selectedRowPrenotazione.item.id != '-1'" @click="onPrenotaAppuntamentoNuovaAccettazione()"> Occupa Slot Prestazione </b-button> -->
                    </div>
                </template>
            </b-modal>
            <b-modal ref="mdlAggiungiAccesso" @hide="onHideAccessoPaziente" @shown="onShownAccessoDiretto"
                title="Aggiungi Accesso Diretto">
                <b-form>
                    <b-row>
                        <b-col cols="12" v-if="completeRicerca">
                            <label>Barcode Paziente</label>
                            <b-input-group>
                                <b-form-input v-model="barcodePaziente"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm" variant="" v-b-tooltip.hover title="Ricerca Paziente"
                                        @click="onCLickRicercaPaziente(barcodePaziente)"><b-icon
                                            icon="search"></b-icon></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <label>Ricetta</label>
                            <b-form-select @change="onChangeRicettaAccessoDiretto" v-model="accessoDiretto.ricettaId">
                                <b-form-select-option v-for="option of ricetteAccessoDirettoOptions" :value="option.id"
                                    :key="option.id">
                                    {{ option.codiceBar1 }} {{ option.codiceBar2 }} Prestazioni n. {{
                                        option.prestazioni.length }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="6">
                            <label>Prestazione</label>
                            <b-form-select @change="onChangePrestazioneAccessoDiretto"
                                v-model="accessoDiretto.prestazioneId">
                                <b-form-select-option v-for="option of prestazioneAccessoDirettoOptions"
                                    :value="option.id" :key="option.id">
                                    {{ option.descrizionePrestazione }} ({{ option.codicePrestazione }})
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="6">
                            <label>Ambulatorio/Agenda</label>
                            <b-form-select @change="onChangeAmbulatorioAgenda" v-model="accessoDiretto.agendaId">
                                <b-form-select-option v-for="option of agendeAccessoDirettoOptions" :value="option.id"
                                    :key="option.id">
                                    {{ option.titolo }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>

                        <b-col cols="6">
                            <label>Data Ora Accesso</label>
                            <b-form-input :disabled="true" :value="getDescrizioneDataOraAccesso()">
                            </b-form-input>

                        </b-col>
                        <b-col cols="12" style="padding:8px">
                            <b-row>
                                <b-col cols="4" class="text-center">
                                    <div class="compact-number-container">
                                        <label class="number-label">Num.Accessi</label>
                                        <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroAccessi }}</div>
                                    </div>
                                </b-col>
                                <b-col cols="4">
                                    <div class="compact-number-container">
                                        <label class="number-label">Num.Prenotazioni</label>
                                        <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroPrenotati }}
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="4">
                                    <div class="compact-number-container">
                                        <label class="number-label">Fine Ciclo in</label>
                                        <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroAccessiMancanti
                                            }}
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="12" class="text-center my-3">
                            <div
                                class="d-inline-flex align-items-center justify-content-center p-2 px-3 bg-light rounded-pill border shadow-sm">
                                <span class="font-weight-bold text-dark">Stai creando l'Accesso n°</span>
                                <b-badge variant="primary" class="ml-2 px-2 py-1 font-size-lg rounded-circle">
                                    {{ accessoDirettoJsonData.numeroAccessi + 1 }}
                                </b-badge>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <label>Note Aggiuntive</label>
                            <b-form-textarea rows="2" v-model="accessoDiretto.note">
                            </b-form-textarea>
                        </b-col>
                        <b-col cols="12">
                            <hr style="margin: 18px;" />
                            <div class="sa-ft-card-header" v-b-toggle="'collapse-gruppo-accesso'">
                                <div class="sa-ft-section-icon">🚀</div>
                                <h5>Accessi</h5>
                                <div style="display: table; margin-left: auto; text-align: right;">
                                    <span class="sa-ft-circle-wrapper"> </span>
                                    <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroAccessi }}</div>
                                </div>
                                <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                                    :class="{ 'is-open': false }">▼</span>
                            </div>
                            <b-collapse @show="gestisciAperturaAccessi(accessoDirettoJsonData)"
                                @hide="gestisciChiusuraAccessi(accessoDirettoJsonData)" :id="'collapse-gruppo-accesso'">

                                <div class="b-table-sticky-header">
                                    <b-table sticky-header ref="table" stacked="xl" striped hover
                                        :items="accessoDirettoJsonData.accessi" :fields="fieldAccessiPrenotati"
                                        sort-icon-left head-variant="light" class="sa-b-table">
                                        <template #cell(index)="row">
                                            {{ row.index + 1 }}
                                        </template>
                                        <template #cell(numeroOrdine)="row">
                                            <strong style="width: 100%; display: inline-block;">{{
                                                row.item.numeroOrdine }}</strong>

                                        </template>
                                    </b-table>
                                </div>


                            </b-collapse>
                            <div class="sa-ft-card-header" v-b-toggle="'collapse-gruppo-prenotazioni'">
                                <div class="sa-ft-section-icon">🚀</div>
                                <h5>Prenotazioni</h5>
                                <div style="display: table; margin-left: auto; text-align: right;">
                                    <span class="sa-ft-circle-wrapper"> </span>
                                    <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroPrenotati }}
                                    </div>
                                </div>
                                <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                                    :class="{ 'is-open': false }">▼</span>
                            </div>
                            <b-collapse @show="gestisciAperturaPrenotazioni(accessoDirettoJsonData)"
                                @hide="gestisciChiusuraPrenotazioni(accessoDirettoJsonData)"
                                :id="'collapse-gruppo-prenotazioni'">
                                <div class="b-table-sticky-header">
                                    <b-table sticky-header style="height: 250px !important;" ref="table" stacked="xl"
                                        striped hover responsive :items="accessoDirettoJsonData.prenotati"
                                        :fields="fieldAccessiPrenotati" sort-icon-left head-variant="light"
                                        class="sa-b-table">
                                        <template #cell(index)="row">
                                            {{ row.index + 1 }}
                                        </template>
                                        <template #cell(numeroOrdine)="row">
                                            <strong style="width: 100%; display: inline-block;">{{
                                                row.item.numeroOrdine }}</strong>
                                        </template>
                                    </b-table>
                                </div>


                            </b-collapse>
                        </b-col>

                    </b-row>
                </b-form>
                <template #modal-footer>
                    <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">

                        <b-button variant="danger" @click="onAnnullaAccessoDiretto">Annulla</b-button>
                        <b-button variant="success"
                            :disabled="accessoDirettoJsonData.appuntamentoPresenteGiornoCorrente"
                            @click="aggiungiAccessoDiretto"> Crea Accesso
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
// import axios from "axios";

// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast.js";
import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    //PrintComponent
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            pathResource: "/agendaappuntamenti?barcode=",
            pathResourceRicette: "/accettazionericette",
            dataRiferimentoDate: null,
            items: [],
            righeAperte: [],
            rows: 0,
            barcodePaziente: "",
            accessoDiretto: {
                agendaId: null,
                ricettaId: null,
                prestazioneId: null,
                dataRiferimento: null,
                note: ""
            },
            idAccettazione: null,
            appuntamentiTmpConferma: [],
            tabSpostaAppuntamento: 1,
            disponibilitaAgendaItems: [{ disponibilita: [] }],
            pathResourceAgendaDisponibilita: "/agendadisponibilita",
            jsonData: {
                orderId: null,
                orderStatus: "EROGATO",
                reasonId: 0
            },
            filtro: {
                codiceFiscaleAssistito: null,
                idPresidio: null,
            },
            appuntamentoSelezionatoDaSpostare: {

            },
            presidio: {},
            orderStutusOptions: ["ESEGUITO", "NON ESEGUITO"],
            reasonIdOptions: [],
            spostaAppuntamentoJsonData: {
                idAgenda: null,
            },
            page: 1,
            perPage: 10000,
            signedPdfViewer: null,
            appuntamentoSelRow: {
                statoAttuale: ""
            },
            prestazioneSelezionata: {
                appuntament: []
            },
            agendaOptions: [],
            listKey: 0,
            previewSelected: null,
            currentPage: 1,
            rowSelectedAccettazione: {},
            dataRiferimento: null,
            listaRicetteDetails: {},
            jsonDataAccettazione: {},

            nuovaDisponibilitaSelezionata: null,
            fieldDisponibilita: [
                { key: 'seleziona', label: '', thStyle: 'width: 50px' },
                { key: 'dataRiferimento', label: 'Slot' },

            ],
            fieldAppuntamenti: [

                {
                    label: "Ordine Appuntamento",
                    key: "numeroOrdine",
                    thStyle: "width: 8rem",
                },
                {
                    label: "Appuntamento",
                    key: "riferimento",
                    thStyle: "width: 15rem",
                },
                {
                    label: "Stato Appuntamento",
                    key: "statoAttuale",
                },
            ],
            fieldAccessiPrenotati: [
                {
                    label: "C.F Assistito",
                    key: "identificativoAppuntamento",
                },
                {
                    label: "Prestazione",
                    key: "descrizionePrestazione",
                },
                {
                    label: "Appuntamento",
                    key: "dataOraInizio",
                    formatter: (v) => {
                        return this.formatDateTime(v);
                    }
                },
                {
                    label: "Accesso N°",
                    key: "numeroOrdine",
                },
            ],
            fields: [
                {
                    label: "Nre",
                    key: "nre",

                },
                {
                    label: "C.F Assistito",
                    key: "identificativoAppuntamento",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                },
                {
                    label: "Prestazione",
                    key: "descrizionePrestazione",
                    thStyle: "width: 35rem",

                },

                {
                    label: "Ciclo",
                    key: "ciclo",
                    thStyle: "width: 12.5rem",

                },
                {
                    label: "Appuntamento",
                    key: "riferimento",
                    thStyle: "width: 8rem",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],

            completeRicerca: false,
            agendeAccessoDirettoOptions: [],
            ricetteAccessoDirettoOptions: [],
            prestazioneAccessoDirettoOptions: [],
            accessoDirettoJsonData: {
                numeroAccessi: 0,
                ciclo: 1,
                numeroPrenotati: 0,
                numeroAccessiMancanti: 1,
                accessi: [],
                prenotati: []
            }


        };
    },
    mounted() {
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio) {
            let presidio = JSON.parse(tmpPresidio);
            this.presidio = presidio;
            this.loadAgende()
        }
        this.idAccettazione = this.$route.query.idAccettazione
        this.filtro.dataRiferimentoAl = new Date().getTime();
        //GESTIONE SE PER PAZIENTE O LISTA RECUPERO TRAMITE BARCODE E POI PRENDO API.
        if (this.idAccettazione) {
            this.loadDataAccettazione();
            this.completeRicerca = false;
        } else {
            this.completeRicerca = true;
        }
    },

    computed: {
        disponibilitaAgenda() {
            let me = this;
            let returnValue = [
                {
                    giorno: me.dataRiferimento,
                    disponibilita: [],
                },
            ];
            if (me.disponibilitaAgendaItems != null)
                if (me.disponibilitaAgendaItems[0]) {
                    let disponibilita = me.disponibilitaAgendaItems[0].disponibilita;
                    for (let dis of disponibilita) {
                        let listaAccessi = dis.appuntamento.length;
                        for (let i = 0; i < listaAccessi; i++) {
                            let slotDisp = false;
                            if (dis.appuntamento[i] === null) {
                                slotDisp = true;
                            }
                            if (slotDisp) {
                                const dataI = new Date(`${dis.dataRiferimento}T${dis.dalleOre}`);
                                if (new Date() < dataI) {
                                    returnValue[0].disponibilita.push(dis);
                                }
                            }
                        }
                    }
                    returnValue[0].disponibilita = new Set(returnValue[0].disponibilita);

                }

            return returnValue;
        },
    },
    watch: {
        dataRiferimentoDate: function (params) {
            this.dataRiferimento = moment(params).format("YYYY-MM-DD");

        },
        dataRiferimento: function (params) {
            let me = this;
            if (params) {
                me.loadAgendaDisponibilita();
            }
        },
    },
    methods: {
        init(filtro, dataRiferimento) {
            this.filtro = filtro;
            this.dataRiferimento = dataRiferimento;
            this.loadData();
        },
        onClickEliminaAppuntamento(item) {
            console.log(item);

            this.$bvModal
                .msgBoxConfirm("Sei sicuro di voler eliminare questo appuntamento ?", {
                    title: "Eliminazione Appuntamento schedulato",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.eliminaAppuntamento(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

        },
        onCLickRicercaPaziente(item) {
            this.openShowModalLoading();
            let filtro = {
                codiceFiscaleAssistito: item
            }
            this.loadDataResources("/accettazionessn", filtro, this.loadDataBarcodeSuccess, this.loadDataBarcodeError);
        },
        loadDataBarcodeSuccess(response) {
            if (response.data.data.list) {
                if (response.data.data.list[0]) {
                    let idAccettazione = response.data.data.list[0].id
                    let link = process.env.VUE_APP_PATH_API + "/accettazionessn/" + idAccettazione;
                    axios.get(link).then((response) => {
                        this.jsonDataAccettazione = response.data.data;
                        if (this.completeRicerca) {
                            this.ricetteAccessoDirettoOptions = this.jsonDataAccettazione.ricette;
                        }
                    }).catch(() => {
                        this.closeShowModalLoading();
                    });
                }
            }
            this.closeShowModalLoading();

        },
        loadDataBarcodeError() {
            this.closeShowModalLoading();
        },
        eliminaAppuntamento(item) {

            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/" + item.id;
            axios.delete(link).then(() => {
                toast.success("Eliminato con successo !")
                this.loadData();
            });
        },
        gestisciAperturaAccessi(item) {
            if (item) {
                this.$set(item, 'isOpenAccessi', true);
            }
            this.isOpen = true;
        },
        gestisciChiusuraAccessi(item) {
            if (item) {
                this.$set(item, 'isOpenAccessi', false);
            }
            this.isOpen = false;
        },
        gestisciAperturaPrenotazioni(item) {
            if (item) {
                this.$set(item, 'isOpenPrenotazioni', true);
            }
            this.isOpen = true;
        },
        gestisciChiusuraPrenotazioni(item) {
            if (item) {
                this.$set(item, 'isOpenPrenotazioni', false);
            }
            this.isOpen = false;
        },
        getGiornoSettimana(dataString) {
            if (!dataString) return '--';
            const giornoSettimana = moment(dataString).locale('it').format('dddd');
            return giornoSettimana;
        },

        giornoSettimanaFormattata(data) {
            if (!data) return '--';
            return moment(data, "DD/MM/YYYY").format("dddd");
        },

        getDescrizioneDataOraAccesso() {
            let returnValue = this.accessoDiretto.dataRiferimento;
            if (this.accessoDiretto.dataRiferimento) {
                let giornoSettimana = this.getGiornoSettimana(this.accessoDiretto.dataRiferimento.split(" ")[0]).toUpperCase();
                returnValue = giornoSettimana + " " + this.formattaDataCustom(returnValue);
            }


            return returnValue;
        },
        onAnnullaAccessoDiretto() {
            this.$refs.mdlAggiungiAccesso.hide();
        },

        formattaData(dataString) {
            if (!dataString) return '--';
            const parti = dataString.split('-');
            return `${parti[2]}/${parti[1]}/${parti[0]} `;
        },

        formattaDataCustom(dataString) {
            if (!dataString) return '--';
            const date = dataString.split(' ');
            const parti = date[0].split("-");

            return `${parti[2]}/${parti[1]}/${parti[0]} ${date[1]}`;
        },
        loadData() {
            this.openShowModalLoading();
            if (this.filtro.idPresidio == null) {
                toast.warning("Id Presidio Obbligatorio")
                this.closeShowModalLoading();
                return;
            }

            this.loadDataResources("/accettazionericetteprestazioniagendaappuntamento/barcode", this.filtro, this.loadDataAccettazioneSsnSuccess, this.loadDataAccettazioneSsnError);
        },
        onClickSpostaAppuntamento() {

            this.openShowModalLoading()

            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/sposta/" + this.spostaAppuntamentoJsonData.id;
            axios.put(link, this.spostaAppuntamentoJsonData)
                .then((response) => {
                    this.closeShowModalLoading()
                    toast.success(response.data.messaggio);
                    setTimeout(() => {
                        this.loadData();
                    }, 1000);

                })
                .catch((e) => {
                    this.closeShowModalLoading();
                    toast.error(e?.response?.data?.messaggio)

                });
        },
        loadDataAccettazione() {
            let link = process.env.VUE_APP_PATH_API + "/accettazionessn/" + this.idAccettazione;
            axios.get(link).then((response) => {
                this.jsonDataAccettazione = response.data.data;
            });
        },

        onChangeRicettaAccessoDiretto(id) {
            let ricetta = this.ricetteAccessoDirettoOptions.find(e => e.id == id);
            if (ricetta) {
                this.prestazioneAccessoDirettoOptions = ricetta.prestazioni;
            } else {
                this.prestazioneAccessoDirettoOptions = [];
            }
        },

        onClickAggiungiAccessoDiretto() {
            if (!this.completeRicerca) {
                this.ricetteAccessoDirettoOptions = this.jsonDataAccettazione.ricette;
            }
            this.$refs.mdlAggiungiAccesso.show();
        },
        onChangePrestazioneAccessoDiretto(prestazione) {
            let prestazioneSelezionata = this.prestazioneAccessoDirettoOptions.find(e => e.id == prestazione)
            let codicePrestazione = prestazioneSelezionata.codicePrestazione;
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/agende?codicePrestazione=" + codicePrestazione + "&idPresidio=" + this.presidio.idPresidio;
            axios.get(link).then((response) => {
                this.agendeAccessoDirettoOptions = response.data.data;
                this.closeShowModalLoading();
            }).catch(() => {
                this.closeShowModalLoading();
            });
            this.getAccessiPaziente();

        },
        onChangeAmbulatorioAgenda(a) {
            let agenda = this.agendeAccessoDirettoOptions.find(e => e.id == a)
            console.log(agenda.prestazioni);
        },
        onShownAccessoDiretto() {
            this.accessoDiretto.dataRiferimento = moment(new Date().getTime()).format("YYYY-MM-DD HH:mm");
        },

        onHideAccessoPaziente() {
            this.accessoDiretto = {
                agendaId: null,
                ricettaId: null,
                prestazioneId: null,
                dataRiferimento: null,
                note: ""
            }
        },

        getAccessiPaziente() {
            this.openShowModalLoading();
            let data = this.accessoDiretto.dataRiferimento.split(" ");
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni" + "/" + this.accessoDiretto.prestazioneId + "/accessi?dataRiferimento=" + data[0];
            axios.get(link).then((response) => {
                this.accessoDirettoJsonData = response.data.data;
                if (this.accessoDirettoJsonData.appuntamentoPresenteGiornoCorrente) {
                    toast.warning("Gia Prevista un'appuntamento per il Paziente per la prestazione!")
                }

                this.closeShowModalLoading();
            }).catch(() => {
                this.closeShowModalLoading();
            });

        },
        validazioneAccessoDiretto() {
            let esito = true;
            let msg = "";
            if (this.accessoDiretto.agendaId == null) {
                msg += "Seleziona Agenda ! #";
                esito = false;
            }
            if (this.accessoDiretto.ricettaId == null) {
                msg += "Seleziona Ricetta ! #";
                esito = false;
            }
            if (this.accessoDiretto.prestazioneId == null) {
                msg += "Seleziona Prestazione ! #";
                esito = false;
            }

            return { esito: esito, msg: msg };
        },

        aggiungiAccessoDiretto() {

            let validation = this.validazioneAccessoDiretto();
            if (!validation.esito) {
                toast.validation(validation)
                return;
            }
            let prestazioneSelezionata = this.prestazioneAccessoDirettoOptions.find(e => e.id == this.accessoDiretto.prestazioneId)

            console.log(this.accessoDiretto);
            console.log(prestazioneSelezionata);
            let dataRif = this.accessoDiretto.dataRiferimento.split(" ")[0];
            let dataOraInizio = this.convertiInTimestamp(dataRif, this.accessoDiretto.dataRiferimento.split(" ")[1]);

            let dataOraFine = dataOraInizio;

            let appuntamentoAgenda = {
                idAgenda: this.accessoDiretto.agendaId,
                cognome: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.cognome : "N/D",
                tipoIdentificativo: "CF",
                identificativoAppuntamento: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.identificativo : "N/D",
                codicePrestazione: prestazioneSelezionata.codicePrestazione,
                descrizionePrestazione: prestazioneSelezionata.descrizionePrestazione,
                dataOraInizio: dataOraInizio,
                dataOraFine: dataOraFine,
                dataRiferimento: dataRif,
                numeroOrdine: this.accessoDirettoJsonData.numeroAccessi + 1,
                costo: prestazioneSelezionata.prezzo,
                nome: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.nome : "",
                dataNascita: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.dataNascita : null,
                note: this.accessoDiretto.note,
                statoAttuale: "ESEGUITO",
                idRicettaPrestazione: this.accessoDiretto.prestazioneId,
                statoAttualeDataOra: new Date().getTime()
            };

            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/accesso";
            axios.post(link, appuntamentoAgenda).then(() => {
                this.$refs.mdlAggiungiAccesso.hide();
                this.loadData();
                this.closeShowModalLoading();
            }).catch((err) => {
                this.closeShowModalLoading();
                toast.error(err.response.data.messaggio)
            });


        },



        gestioneAppuntamenti(row) {

            this.appuntamentoSelRow = row;
            this.$refs.mdlGestioneAppuntamento.show();

        },
        onAnnullaSpostaAppuntamento() {
            this.$refs.mdlGestioneAppuntamento.hide();
        },
        onIndietroSpostaAppuntamento() {

            this.appuntamentoSelezionatoDaSpostare = {}
        },
        onShownGestioneAppuntamento() {
            this.openShowModalLoading()
            let appuntamento = this.appuntamentoSelRow;
            let idPrestazione = appuntamento.idPrestazione;
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni/" + idPrestazione;
            axios
                .get(link)
                .then((response) => {
                    this.prestazioneSelezionata = response.data.data;
                    this.loadAgendaDisponibilita();
                    this.closeShowModalLoading();

                })
                .catch((e) => {
                    console.log(e);
                    this.closeShowModalLoading();
                });


        },
        getOrario(data) {
            return moment(data).format("HH:mm");
        },
        loadAgende() {
            let link = process.env.VUE_APP_PATH_API + "/agende";
            axios
                .get(link, { params: this.filtro })
                .then((response) => {
                    this.agendaOptions = response.data.data;

                })
                .catch((e) => {
                    console.log(e);
                });

        },
        loadDataAccettazioneSsnSuccess(response) {
            this.items = response.data.data;
            this.rows = this.items.length;


            this.closeShowModalLoading();
        },
        loadDataAccettazioneSsnError(response) {
            response;
            this.closeShowModalLoading();

        },
        setData(dataRiferimento) {
            this.dataRiferimento = dataRiferimento;
            this.loadData();
        },

        getInfoCiclo(item) {
            return item.infoAppuntamento;
        },

        getInfoAgenda(item) {
            let returnValue = "";
            let agenda = item.idAgenda;
            let agendaObj = this.agendaOptions.find(e => e.id == agenda);
            if (agendaObj) {
                returnValue = agendaObj.descrizione;
            }
            return returnValue.toUpperCase()
        },
        setRowSelected(item) {
            if (item && item.length > 0) {
                let app = item[0];
                if (app.statoAttuale == "ESEGUITO" || app.statoAttuale == "NON ESEGUITO") {
                    this.appuntamentoSelezionatoDaSpostare = {};
                    toast.warning("Appuntamento già marcato come " + app.statoAttuale + " , non è possibile spostare!");
                    this.$refs.table.clearSelected();
                    return;
                }
                this.appuntamentoSelezionatoDaSpostare = app;
                this.spostaAppuntamentoJsonData = JSON.parse(JSON.stringify(app));
                this.dataRiferimentoDate = new Date().getTime();
            } else {
                this.appuntamentoSelezionatoDaSpostare = {};
            }
        },

        convertiInTimestamp(data, ora) {

            const dateFinal = `${data}T${ora}:00`;
            return new Date(dateFinal).getTime();



        },
        onDisponibilitaSelected(items) {


            if (items && items.length > 0) {
                this.nuovaDisponibilitaSelezionata = items[0];
                this.spostaAppuntamentoJsonData.dataRiferimento = this.nuovaDisponibilitaSelezionata.dataRiferimento
                this.spostaAppuntamentoJsonData.alleOre = this.nuovaDisponibilitaSelezionata.alleOre
                this.spostaAppuntamentoJsonData.dalleOre = this.nuovaDisponibilitaSelezionata.dalleOre
                this.spostaAppuntamentoJsonData.dataOraFine = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.alleOre)
                this.spostaAppuntamentoJsonData.dataOraInizio = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.dalleOre)
                this.spostaAppuntamentoJsonData.costo = this.appuntamentoSelRow.costo;
                this.spostaAppuntamentoJsonData.codiceBar1 = this.appuntamentoSelRow.codiceBar1;
                this.spostaAppuntamentoJsonData.codiceBar2 = this.appuntamentoSelRow.codiceBar2;
                this.spostaAppuntamentoJsonData.quantitaErogabile = this.appuntamentoSelRow.quantitaErogabile

                let appuntamentiTmp = JSON.parse(JSON.stringify(this.prestazioneSelezionata.appuntament));

                const index = appuntamentiTmp.findIndex(app => app.id === this.appuntamentoSelezionatoDaSpostare.id);
                console.log(index);

                if (index !== -1) {
                    appuntamentiTmp[index] = JSON.parse(JSON.stringify(this.spostaAppuntamentoJsonData));
                }
                appuntamentiTmp.sort((a, b) => a.dataOraInizio - b.dataOraInizio);
                appuntamentiTmp = appuntamentiTmp.map((app, idx) => {
                    const nuovoOrdine = idx + 1;
                    if (app.id == this.appuntamentoSelezionatoDaSpostare.id) {
                        this.spostaAppuntamentoJsonData.numeroOrdine = nuovoOrdine;
                    }
                    app.numeroOrdine = nuovoOrdine;
                    return app;
                });
                this.appuntamentiTmpConferma = appuntamentiTmp;
            } else {
                this.nuovaDisponibilitaSelezionata = null;
            }
        },

        onHide() {
            this.appuntamentoSel = null;
            this.appuntamentoSelezionatoDaSpostare = {};
            this.nuovaDisponibilitaSelezionata = null;
            if (this.$refs.table) this.$refs.table.clearSelected();
            if (this.$refs.tblDisponibilita) this.$refs.tblDisponibilita.clearSelected();
        },
        onHideChangeStato() {
            this.jsonData = {}
        },

        onChangeStatoPrenotazione(item) {
            this.appuntamentoSel = item;
            this.$refs.mdlChangeStato.show();
        },
        onChangeSelectStato(params) {
            if (params == 'PRENOTATO' || params == "ACCETTATO" || params == "EROGATO") {
                this.jsonData.reasonId = 0;
            }
        },
        onCambiaStato() {
            this.openShowModalLoading();
            console.log("agendaappuntamentistatistorico");
            let request = {
                stato: this.jsonData.stato,
                idAppuntamento: this.appuntamentoSel.id,
                dataOra: new Date().getTime(),
            }
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentistatistorico";
            axios.post(link, request).then(() => {
                toast.success("Cambio stato avvenuto con successo: " + this.jsonData.stato)
                this.loadData();
                this.closeShowModalLoading();
                this.$refs.mdlChangeStato.hide();
            }).catch((erro) => {
                erro;
                this.closeShowModalLoading();
            });
        },

        loadAgendaDisponibilita() {
            let me = this;
            if (JSON.stringify(this.appuntamentoSelezionatoDaSpostare) != "{}") {
                let itemFIlter = {
                    language: "it",
                    idAgenda: this.appuntamentoSelezionatoDaSpostare.idAgenda,
                    periodo: "G",
                    riferimento: me.dataRiferimento,
                    codicePrestazione: this.appuntamentoSelezionatoDaSpostare.codicePrestazione,
                };
                me.disponibilitaAgendaItems = [{ disponibilita: [] }];
                this.openShowModalLoading();
                UtilityMixin.methods.loadDataResources(me.pathResourceAgendaDisponibilita, itemFIlter, me.loadAgendaDisponibilitaSuccess, me.loadAgendaDisponibilitaError);
            }
        },
        loadAgendaDisponibilitaSuccess(response) {
            let me = this;
            me.disponibilitaAgendaItems = response.data.data;
            this.closeShowModalLoading();
        },
        loadAgendaDisponibilitaError(error) {
            console.log(error);
            this.closeShowModalLoading();
        },


    },
};
</script>

<style scoped>
.ft-wrapper-ricetta {
    margin-bottom: 16px;
}

.compact-number-container {
    display: inline-flex;
    /* Occupa solo lo spazio necessario */
    flex-direction: column;
    align-items: center;

    /* Spazio minimo tra label e box */
}



.sa-ft-section-icon {
    font-size: 1rem;
    /* Proporzionato alla label */
    background: #f1f5f9;
    width: 28px;
    /* Dimensione ridotta */
    height: 28px;
    /* Dimensione ridotta */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
}

.ft-ricetta-titolo {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
}

/* Prestazioni orizzontali */
.ft-wrapper-prestazioni {
    display: flex;

    gap: 16px;
}

.ft-prestazione-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #f9f9f9;
}

.ft-prestazione-codice {
    font-weight: 600;
    margin-bottom: 6px;
}

.ft-prestazione-badge-container {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
}

.ft-badge {
    min-width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: white;
    font-weight: 600;
}

.ft-badge-complete {
    background-color: #00a3ff;
}

.ft-badge-incomplete {
    background-color: #ffc107;
}

.ft-badge-total {
    background-color: #00a3ff;
}

.sa-badge-internal {
    border-radius: 5px;
    border-left: 4px solid var(--bg-sidebar-item);
    border-top: 1px solid var(--bg-main-nav-bar);
    border-bottom: 1px solid var(--bg-main-nav-bar);
    border-right: 1px solid var(--bg-main-nav-bar);
    padding: 7px !important;
    margin-bottom: 5px;
    max-width: max-content;
}

.sa-badge {
    width: 100%;
    max-width: none !important;
}
</style>
